import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-tryout-registered-members',
  templateUrl: './tryout-registered-members.component.html',
  styleUrls: ['./tryout-registered-members.component.css']
})
export class TryoutRegisteredMembersComponent implements OnInit {

  @Input() NoOfTryoutRegisteredMembers: number;
  @Input() active: boolean;
  @Output() filterMembersEvent = new EventEmitter();

  program_status = '';


  constructor() { }

  ngOnInit() {
  }

  filterMemberListing(value) {
    this.program_status = value;
    this.filterMembersEvent.emit(this.program_status);
  }
}



// WEBPACK FOOTER //
// ./src/app/tryout/components/tryout-registered-members/tryout-registered-members.component.ts